import React from "react"
import { Link } from "gatsby"
import StaffAugmentationImg from "../../../images/staff-augmentation.svg"

const Hero = () => {
  return (
    <section className="container mx-auto md:mt-8 px-6 pb-20">
      <div className="flex flex-col-reverse md:flex-row items-center">
        <div className="flex-1 md:w-1/2 md:pr-4">
          <h1 className="text-5xl lg:text-7xl font-light mb-8 leading-tight">
            <span className="text-secondary font-bold block">Staff</span>{" "}
            Augmentation
          </h1>
          <h3 className="text-3xl pb-8">
            Scale your project's capacity with dedicated professionals
          </h3>
          <Link
            to="/contact"
            className="mx-auto lg:mr-5 lg:mx-0 my-8 hover:text-white hover:bg-secondary hover:text-variant btn"
          >
            Let's do it
          </Link>
        </div>
        <div className="flex-1 my-8 md:my-0 w-full md:w-1/2">
          <img
            src={StaffAugmentationImg}
            alt="Why we are here?"
            className="mx-auto"
            width="500"
          />
        </div>
      </div>
    </section>
  )
}

export default Hero
